import TKTable from '@tk/components/tk.table';

export default class DIWTable extends TKTable {
    constructor() {
        super();
    }

    handleRowLink(event: Event) {
        const target = event.target as HTMLElement;
        if (target.closest('a')) return;
        if (target.closest('button')) return;
        if (target.closest('tk-basket-button')) return;
        const row = target.closest(`[${this.rowLinkSelector}]`);
        if (!row) return;
        const link = row.getAttribute(this.rowLinkSelector);
        if (!link) return;
        window.location.href = link;
    }
}
